// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import "core-js/es6/promise";
import "core-js/es6/string";
import "core-js/es7/array";
// import cssVars from 'css-vars-ponyfill'
import Vue from "vue";
import Vuex from 'vuex'
import BootstrapVue from "bootstrap-vue";
import App from "./App";
import router from "./router";
import Axios from "axios";
import store from "./store.js";
import { ServerTable, ClientTable } from 'vue-tables-2';
import VueSweetalert2 from 'vue-sweetalert2';
import VueLodash from 'vue-lodash';
import JsonExcel from 'vue-json-excel';
import downloadExcel from "vue-json-excel";
import VueExcelXlsx from "vue-excel-xlsx";
import vSelect from 'vue-select';
import Datepicker from 'vuejs-datepicker'
// import { VueEditor } from 'vue2-editor'
import { event }  from './utils/event'
import { CoolSelectPlugin } from 'vue-cool-select'
import 'vue-cool-select/dist/themes/bootstrap.css'
import CKEditor from '@ckeditor/ckeditor5-vue'

import VueMatomo from 'vue-matomo'
import { getIdToken, getAccessToken, getBaseUrl, getProvider} from "@/utils/auth";
// todo
// cssVars()
import 'vue-loading-overlay/dist/vue-loading.css'

import _ from 'lodash';

let DataTableOptions = {
  sortIcon: {
    base: 'fa',
    is: 'fa-sort',
    up: 'fa-sort-asc',
    down: 'fa-sort-desc'
  },
  texts: {
    count: "Affichage de {from} à {to} sur {count} enregistrements | {count} enregistrements | 1 enregistrement",
    first: 'Premiére',
    last: 'Dernière',
    filter: "Filtrer : ",
    limit: "Enregistrements : ",
    page: "Page:",
    noResults: "Aucun enregistrement trouvé",
    filterBy: "Filterer par {column}",
    loading: 'Chargement...',
    defaultOption: 'Sélectionner {column}',
    columns: 'Colonnes'
  }
}

window._ = require('lodash')
event.init()

Vue.prototype.$event = event
Vue.prototype.$eventBus = new Vue()
Vue.use(BootstrapVue)
Vue.use(VueSweetalert2)
Vue.use(ClientTable, DataTableOptions, false, 'bootstrap3')
Vue.use(ServerTable, DataTableOptions, false, 'bootstrap3')
Vue.use(CoolSelectPlugin)
Vue.use( CKEditor )

const user = JSON.parse(localStorage.getItem('user'));
// console.log('user in main.js',user.id)
const AUTH_TOKEN = getIdToken() + ' ' + getAccessToken();
Axios.defaults.baseURL = getBaseUrl();
Axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
Axios.defaults.headers.common['Accept'] = 'application/json';
Axios.defaults.headers.common['Provider'] = getProvider();
Axios.defaults.headers.common['uid'] = user !== null ? user.id : null;

Vue.prototype.$axios = Axios
Vue.prototype._ = _;

const options = { name: 'lodash' }
Vue.use(VueLodash, options)
Vue.component('downloadExcel', JsonExcel)
Vue.use(VueExcelXlsx);

Vue.component('v-select', vSelect)
Vue.component('datepicker', Datepicker)

/* Make axios global */
window.axios = require('axios');

const matomoSiteId = process.env.VUE_APP_MATOMO_SITE_ID
/**** Matomo *****/
Vue.use(VueMatomo, {
  // Configure your matomo server and site by providing
  host: 'https://matomo.chorum.fr',
  siteId: matomoSiteId,

  // Changes the default .js and .php endpoint's filename
  // Default: 'matomo'
  trackerFileName: 'matomo',

  // Enables automatically registering pageviews on the router
  router: router,

  // Enables link tracking on regular links. Note that this won't
  // work for routing links (ie. internal Vue router links)
  // Default: true
  enableLinkTracking: true,

  // Require consent before sending tracking information to matomo
  // Default: false
  requireConsent: false,

  // Whether to track the initial page view
  // Default: true
  trackInitialView: true,

  // Run Matomo without cookies
  // Default: false
  disableCookies: false,

  // Require consent before creating matomo session cookie
  // Default: false
  requireCookieConsent: false,

  // Enable the heartbeat timer (https://developer.matomo.org/guides/tracking-javascript-guide#accurately-measure-the-time-spent-on-each-page)
  // Default: false
  enableHeartBeatTimer: false,

  // Set the heartbeat timer interval
  // Default: 15
  heartBeatTimerInterval: 15,

  // Whether or not to log debug information
  // Default: false
  debug: false,

  // UserID passed to Matomo (see https://developer.matomo.org/guides/tracking-javascript-guide#user-id)
  // Default: undefined
  userId: undefined,

  // Share the tracking cookie across subdomains (see https://developer.matomo.org/guides/tracking-javascript-guide#measuring-domains-andor-sub-domains)
  // Default: undefined, example '*.example.com'
  cookieDomain: undefined,

  // Tell Matomo the website domain so that clicks on these domains are not tracked as 'Outlinks'
  // Default: undefined, example: '*.example.com'
  domains: undefined,

  // A list of pre-initialization actions that run before matomo is loaded
  // Default: []
  // Example: [
  //   ['API_method_name', parameter_list],
  //   ['setCustomVariable','1','VisitorType','Member'],
  //   ['appendToTrackingUrl', 'new_visit=1'],
  //   etc.
  // ]
  preInitActions: [],

  // A function to determine whether to track an interaction as a site search
  // instead of as a page view. If not a function, all interactions will be
  // tracked as page views. Receives the new route as an argument, and
  // returns either an object of keyword, category (optional) and resultsCount
  // (optional) to track as a site search, or a falsey value to track as a page
  // view.
  // Default: false, i.e. track all interactions as page views
  // Example: (to) => {
  //   if (to.query.q && to.name === 'search') {
  //     return { keyword: to.query.q, category: to.params.category }
  //   } else {
  //    return null
  //   }
  // }
  trackSiteSearch: true
});

/* eslint-disable no-new */
new Vue({
  el: "#app",
  store,
  router,
  template: "<App/>",
  components: {
    App
  }
})
